import DescriptionIcon from '@material-ui/icons/Description';
import React, { useCallback } from 'react';
import { useDomainPath } from '../../../auth/auth.context';
import { baseUrl, get } from '../../../fetch';
import { useReservation } from '../reservation.context';
import { Grid, Button } from '@material-ui/core';

/**
 * Interface pour les props du composant ContractButton
 */
interface Props {
  disabled?: boolean;
  fullWidth?: boolean;
}

/**
 * Composant de boutons pour l'impression des contrats
 * 
 * Ce composant :
 * - Affiche les boutons d'impression des contrats standard et OneFlow
 * - Détermine automatiquement la langue du contrat selon le client
 * - Gère l'ouverture des contrats dans de nouvelles fenêtres
 * - Affiche conditionnellement le bouton OneFlow si un contrat existe
 * 
 * Logique métier :
 * - Langue par défaut française si non spécifiée
 * - Impression du contrat standard via URL directe
 * - Impression du contrat OneFlow via API base64
 * - Affichage conditionnel selon l'existence des documents
 * 
 * @param disabled État désactivé des boutons (optionnel)
 * @param fullWidth Largeur complète des boutons (optionnel)
 * @returns Composant React des boutons de contrat
 */
export const ContractButton: React.FC<Props> = props => {
const { reservation, /*reload, save*/ } = useReservation();
  const reservationPath = useDomainPath('/reservation');
  const lang =
  (reservation.customer?.lang === undefined || reservation.customer?.lang === "fr") ?
  "fr" : "en";

  const printContract = useCallback(
    (lang: CRM.I18nLang) => {
      var win = window.open(
        `${baseUrl}/${reservationPath}/${reservation._id}/contract?lang=${lang}`,
        '_blank',
      );
      if(win) {
        // win.print();
      }
    },
    [ reservationPath, reservation._id],
  );

  const printDocusignContract = useCallback(
    () => {
      /*window.open(
        `${baseUrl}/${reservationPath}/${reservation._id}/contract/docusign`,
        '_blank',
      );*/
      get<string>(
        `${reservationPath}/${reservation._id}/contract/oneflow`,
      ).then((base64Pdf: string) => { 
        console.log(base64Pdf);
        let pdfWindow = window.open("")//base64
        pdfWindow && pdfWindow.document.write(
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(base64Pdf.replace('undefined', '')) + "'></iframe>"
        );
      });
    },
    [ reservationPath, reservation._id],
  );

  /*const saveContract = useCallback(() => {
    if (reservation._id) {
      save().then(() => {
        setTimeout(reload, 2000);
      });
    }
  },[save, reload, reservation._id]);*/



  return (
    <Grid
    container
    spacing={3}
    item
    xs={12}
    style={{
      margin: props?.fullWidth === true ? "0" : "auto", 
      marginTop: props?.fullWidth === true ? "1em" : "auto",
    }}
    >
      {/*<Grid
      style={{padding: props?.fullWidth === true ? "0" : "auto"}}
      item xs={12}
      >
        <Button
          {...props}
          color="secondary"
          variant="contained"
          type="button"
          onClick={saveContract}
        >
          Enregistrer
        </Button>
      </Grid>*/}
      <Grid
        style={{padding: props?.fullWidth === true ? "0" : "auto", marginBottom: "1em"}}
        item xs={12} sm={6}
       >
        <Button
            {...props}
            color="secondary"
            variant="contained"
            type="button"
            onClick={()=> {printContract(lang)}}
            startIcon={<DescriptionIcon />}
          >
           Imprimer le contrat
        </Button>
      </Grid>
      { reservation.documents?.oneFlowContract/*.docusignEnvelope*/ && 
        <Grid
        style={{padding: props?.fullWidth === true ? "0" : "auto"}}
        item xs={12} sm={6}
       >
        <Button
            {...props}
            color="secondary"
            variant="contained"
            type="button"
            //disabled={true}
            onClick={()=> {printDocusignContract()}}
            startIcon={<DescriptionIcon />}
          >
           Imprimer le contrat OneFlow
        </Button>
      </Grid>
    }
    </Grid>
  );
};
